import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '@tdwb/core';

import { AdvisorProfile } from '@tdwb/lazy/home';

@Injectable()
export class AdvisorProfileRestService {
  private readonly restService = inject(RestService);

  getProfile(): Observable<Array<AdvisorProfile>> {
    return this.restService.getResource('advisorProfile.advisors').get();
  }
}
